import { Action, State } from 'modules/cm/store/cases/types';
import { ACTION_TYPES } from './types';
import { CaseError } from 'modules/cm/domain/Case/Error';

const reducer = (state: State, action: Action) => {
  return {
    [ACTION_TYPES.SET_CASE_ERRORS]: () => ({
      ...state,
      caseErrors: action.payload[0] as CaseError,
    }),
  };
};

export default reducer;
